// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeAllowance_editButton__8SBph","TableBody":"onetimeAllowance_TableBody__PAHal","deleteButton":"onetimeAllowance_deleteButton__5rkqi"};